module.exports = __webpack_public_path__ + "img/telefono.f0a4dde1.svg";